import React, { createContext, useEffect, useReducer } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'qs';
import { useDebounce } from 'use-debounce';
import { isEmpty } from 'lodash'
import PageNotFound from '../../404';
import {
  changePage,
  listSuccess,
  loadingTable,
  servicesDeletedReducer,
  servicesDeletedState,
  updateListError,
  updateListSuccess,
} from './reducer';
import {
  servicesConfiguration,
  servicesDeletedList,
  servicesProviders,
  servicesTypes,
} from '../../../services/endpoints/services';
import ServicesDeletedHeader from './components/Header';
import ServicesDeletedTable from './components/Table';
import Modals from './components/Modals';
import Loader from '../../../components/Loaders/Loader';

import { pageWrapperScrollTop } from '../../../utils/helper';
import { getErrorMessage } from '../Main/helpers/getters';

export const ServicesDeletedContext = createContext({});
const Services = () => {
  const [servicesDeletedStore, servicesDeletedDispatch] = useReducer(servicesDeletedReducer, servicesDeletedState);
  const { isInitPage, initPageError, updateList, pagination, isLoadingTable, filters } = servicesDeletedStore;

  const {
    providers,
    query,
    search_type,
    type,
    sort,
  } = filters;
  const history = useHistory();
  const location = useLocation();
  const queryString = qs.parse(location.search.slice(1));

  const [urlChangesDebounce] = useDebounce(location.search, 350)
  const updateListing = async () => {
    try {
      const response = await servicesDeletedList(queryString);
      const payload = {
        ...response.data,
      };
      servicesDeletedDispatch(updateListSuccess(payload))
    } catch (error) {
      const data = getErrorMessage(error);
      const status = error?.status ? error.status : 500;
      const statusText = error?.statusText ? error.statusText : 'Unknown error';
      servicesDeletedDispatch(updateListError(data, status, statusText))
    }
  }
  const initPage = async () => {
    try {
      /**
       * 1 - Проверка доступтов в запросе config
       */
      const configuration = await servicesConfiguration();
      const access = configuration?.data?.access;
      if (!access) {
        throw new Error('Error access')
      }

      const requestPull = [
        await servicesDeletedList(queryString),
        await servicesTypes(),
      ];

      /**
       * 2 - Если в My откоючен доступ к провайдерам, не запрашиваем их
       */
      if (access.see_provider_column) {
        requestPull.push(await servicesProviders());
      }

      const [respList, respTypes, respProviders] = await Promise.all(requestPull)
      const payload = {
        configuration: configuration.data,
        types: respTypes.data,
        providers: respProviders ? respProviders.data : [],
        ...respList.data,
      }
      servicesDeletedDispatch(listSuccess(payload))
    } catch (error) {
      const data = getErrorMessage(error);
      const status = error.status ? error.status : 500;
      const statusText = error.statusText ? error.statusText : 'Unknown error';
      servicesDeletedDispatch(updateListError(data, status, statusText))
    }
  }

  useEffect(() => {
    if (!isInitPage) {
      initPage()
    }
    document.title = 'Services deleted';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (isInitPage) {
      servicesDeletedDispatch(loadingTable())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search])

  useEffect(() => {
    if (isInitPage) {
      servicesDeletedDispatch(loadingTable())
      updateListing()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urlChangesDebounce])

  useEffect(() => {
    if (updateList) {
      updateListing()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateList])

  useEffect(() => {
    if (isInitPage && queryString.page) {
      const newPage = queryString.page ? queryString.page : pagination.current_page;
      servicesDeletedDispatch(changePage(newPage))
      pageWrapperScrollTop()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryString.page])

  useEffect(() => {
    if (isInitPage) {
      const searchParams = {};

      if (providers) {
        searchParams.providers = providers;
      }
      if (query) {
        searchParams.query = query;
      }
      if (type !== null) {
        searchParams.type = type;
      }
      if (search_type && query) {
        searchParams.search_type = search_type;
      }
      if (sort !== null) {
        searchParams.sort = sort;
      }
      if (queryString.page) {
        searchParams.page = queryString.page;
      }

      history.push({
        pathname: '/services/deleted',
        search: isEmpty(searchParams) ? '' : `?${ new URLSearchParams(searchParams).toString()}`,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, providers, type, search_type, sort])

  if (!isInitPage) {
    return <Loader />;
  }

  if (isInitPage && initPageError) {
    return (
      <PageNotFound errorDataMessage={initPageError?.data} errorStatus={initPageError?.status} errorStatusText={initPageError?.statusText} />
    )
  }

  return (
    <ServicesDeletedContext.Provider
      value={[servicesDeletedStore, servicesDeletedDispatch]}
    >
      <div>
        <ServicesDeletedHeader />
        <ServicesDeletedTable
          pagination={pagination}
          isLoadingTable={isLoadingTable}
        />
      </div>
      <Modals />
    </ServicesDeletedContext.Provider>
  );
};

export default Services;
